import { faLink } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";

export const ProjectCard = ({
  title,
  description,
  imgUrl,
  url,
  handleScrollToTop,
}) => {
  const tooltip = <Tooltip id="tooltip-visit-website">Visit website</Tooltip>;

  return (
    <Col size={12} md={6} lg={4}>
      <div className="proj-imgbx">
        <img src={imgUrl} alt="" />
        <div className="proj-txtx">
          <div className="d-flex justify-content-center">
            <h4>{title} </h4>
            <OverlayTrigger placement="top" overlay={tooltip}>
              <FontAwesomeIcon
                icon={faLink}
                style={{
                  fontSize: "16px",
                  padding: 6,
                  cursor: "pointer",
                }}
                onMouseEnter={(e) => (e.target.style.color = "#4691B8")}
                onMouseLeave={(e) => (e.target.style.color = "white")}
                onClick={() => window.open(url, "_blank")}
              />
            </OverlayTrigger>
          </div>
          <span>{description}</span>

          <Col size={12}>
            <div className="mt-2">
              <Link
                to={`/project/${title.toLowerCase()}`}
                style={{ bg: "none" }}
              >
                <button
                  type="button"
                  style={{
                    fontWeight: "bold",
                    color: "black",
                  }}
                  onMouseEnter={(e) => (e.target.style.color = "darkblue")}
                  onMouseLeave={(e) => (e.target.style.color = "black")}
                  onClick={handleScrollToTop ? handleScrollToTop : null}
                >
                  See Description
                </button>
              </Link>
            </div>
          </Col>
        </div>
      </div>
    </Col>
  );
};
